import { Injectable, Injector }  from '@angular/core';
import { Router }      from '@angular/router';
import { environment } from '../../environments/environment'


import { tokenNotExpired, JwtHelper } from 'angular2-jwt';
import { AppConfig } from '../app.config';
import * as auth0 from 'auth0-js';
import { RequestService } from './request.service';
import { Admin } from '../classes/admin';

(window as any).global = window;

var Moment = require('moment');

declare var Auth0: any;
const TIME_TO_UPDATE_ADMIN = 3600 //1 hour in seconds

@Injectable()
export class Auth {

  private auth0 = new auth0.WebAuth({
    domain: this.config.get('AUTH_0_DOMAIN'),
    clientID: this.config.get('AUTH_0_CLIENT_ID'),
    responseType: 'token',
    //scope:'openid',
    //responseMode:'query',
    redirectUri: this.config.get('callbackAuth')//window.location + 'index.html?/dashboard' //this.config.get('callbackAuth')//environment.config.callbackAuth
  });

  admin:boolean=false;

  jwtHelper: JwtHelper = new JwtHelper();


  constructor(private router: Router, private config: AppConfig) {

    /*var result = this.auth0.parseHash(window.location.hash);
    window.location.hash = '';

    if (result && result.idToken) {

      localStorage.setItem('id_token', result.idToken);
      localStorage.setItem('access_token', result.accessToken);
    } else if (result && result.error) {

      alert('error: ' + result.error);
    }*/
    this.handleAuthentication()
    this.checkAdmin()
  }
  public handleAuthentication() {
      console.log("Start handling");
      localStorage.setItem('logging', "1");
      this.auth0.parseHash((err, authResult) => {
        if (authResult && authResult.idToken) {
          window.location.hash = '';
          /*localStorage.setItem('id_token', authResult.idToken);
          localStorage.setItem('access_token', authResult.accessToken);*/
          this.setSession(authResult)
          console.log("Ended handling",authResult);
          this.router.navigate(['/dashboard']);
        } else if (err) {
          //this.router.navigate(['/login']);
          console.log("error handle authentication",err);
          localStorage.setItem('logging', "0");
        }
        else{
          localStorage.setItem('logging', "0");
        }
      });
  }

  private setSession(authResult): void {
    // Set the time that the Access Token will expire at
    console.log("Setting session..")
    const expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);
    console.log("Setted session");
    localStorage.setItem('logging', "0");

  }

  public login(username: string, password: string) {
    /**
     * We are using the Auth0 Universal login
     * The commented code below is for the latest auth0 sdk which
     * seems to work but it shouldn't because we dont use custom domain.
     */
    /*this.auth0.login({
      realm: 'Username-Password-Authentication',
      //responseType: 'token',
      email: username,
      password: password,
    }, function(err: any) {
      if (err) alert("something went wrong: " + err.message);
      console.log(err)
    });  */
    if (localStorage.getItem('logging')!="1"){
      console.log("Going to Auth0 unviersal login...");
      localStorage.clear()
      this.auth0.authorize();
    }

  }

  public authenticated() {

    // Check if there's an unexpired JWT
    // This searches for an item in localStorage with key == 'id_token'
    return tokenNotExpired();
    //const expiresAt = JSON.parse(localStorage.getItem('expires_at') || '{}');
    //return new Date().getTime() < expiresAt;
  }

  public getAccessToken() {

    return localStorage.getItem('access_token');
  }

   public getIdToken() {

    return localStorage.getItem('id_token');
  }

  public logout() {

    // Remove token from localStorage
    this.admin=false;
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  public putAdmin(admin){
    this.admin=true;
    localStorage.setItem('admin','1')
    localStorage.setItem('adminInfo', JSON.stringify(admin))
    localStorage.setItem('lastAdminFetchAt', Moment().unix())
  }

  public getAdmin(){
    return JSON.parse(localStorage.getItem('adminInfo'));
  }
  public isAdmin(){
    return this.admin
  }

  private checkAdmin(){
    this.admin = localStorage.getItem('admin')==='1'
  }

  public getAdminAuht0Id() {
    const token = this.getIdToken();
    return this.jwtHelper.decodeToken(token).user_id;
  }

  public shouldFetchAdmin() {
    var lastFetch = Number(localStorage.getItem('lastAdminFetchAt'))
    console.log("TIME SINCE LAST FETCH", Moment().unix() - lastFetch, "seconds")
    return !lastFetch || Moment().unix() - lastFetch > TIME_TO_UPDATE_ADMIN
  }

  //admin permissions
  public hasWritePatientPermission() {
    return this.getAdmin() && this.getAdmin().permissions.indexOf("writePatient") !== -1
  }
  public hasWriteDoctorPermission() {
    return this.getAdmin() && this.getAdmin().permissions.indexOf("writeDoctors") !== -1
  }
  public hasWriteProviderPermission() {
    return this.getAdmin() && this.getAdmin().permissions.indexOf("writeProvider") !== -1
  }
  public hasBOUsersPermission() {
    return this.getAdmin() && this.getAdmin().permissions.indexOf("writeBOUsers") !== -1
  }
  public hasReportsPermission() {
    return this.getAdmin() && this.getAdmin().permissions.indexOf("reports") !== -1
  }
  public hasSysOpsPermission() {
    return this.getAdmin() && this.getAdmin().permissions.indexOf("sysOps") !== -1
  }
  public hasPatientValidationPermission() {
    return this.getAdmin() && this.getAdmin().permissions.indexOf("patientValidation") !== -1
  }
  public hasClinicalHistoryPermission() {
    return this.getAdmin() && this.getAdmin().permissions.indexOf("clinicalHistory") !== -1
  }
  public hasWriteCallsPermission() {
    return this.getAdmin() && this.getAdmin().permissions.indexOf("writeCalls") !== -1
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts